import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "icon" }
const _hoisted_2 = {
  key: 0,
  class: "link-text heading-6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    class: "menu-link",
    to: $props.url
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "icon")
      ]),
      ($props.isOpened)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($props.text), 1))
        : _createCommentVNode("", true),
      ($props.isOpened)
        ? _renderSlot(_ctx.$slots, "suffix", { key: 1 })
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["to"]))
}